import type { ReactElement } from 'react';
import { renderScript } from '@arcnet/contracts';

/**
 * A script step's text, filled in (docs/36 §8.3). Built from renderScript's plain strings as React
 * text: nothing here is ever parsed as HTML, so a lead's values -- a client's spreadsheet -- are
 * only ever words on the screen. A variable with no value is shown as missing, never as a blank.
 */
export function ScriptText({ text, vars }: { text: string; vars: Readonly<Record<string, string | null | undefined>> }) {
  const blocks = renderScript(text, vars);
  const items: ReactElement[] = [];
  let list: ReactElement[] = [];
  const flush = () => {
    if (list.length) items.push(<ul key={`ul${items.length}`} style={{ margin: '4px 0 8px', paddingLeft: 20 }}>{list}</ul>);
    list = [];
  };
  blocks.forEach((b, i) => {
    const spans = b.spans.map((s, j) => {
      const style = s.bold ? { fontWeight: 650 } : undefined;
      if (s.kind === 'missing') {
        return (
          <mark key={j} title={`No ${s.name} for this lead`} className="arc-mono"
            style={{ ...style, background: 'var(--arc-warn-bg)', color: 'var(--arc-warn)', padding: '0 3px', borderRadius: 3, fontSize: '0.9em' }}>
            {s.name}?
          </mark>
        );
      }
      return <span key={j} style={{ ...style, whiteSpace: 'pre-wrap' }}>{s.text}</span>;
    });
    if (b.type === 'li') { list.push(<li key={i}>{spans}</li>); return; }
    flush();
    items.push(<p key={i} style={{ margin: '0 0 8px' }}>{spans}</p>);
  });
  flush();
  return <div style={{ fontSize: 14, lineHeight: 1.5 }}>{items.length ? items : <span className="arc-subtle">Nothing to say on this step.</span>}</div>;
}
